var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_21469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0V25L25 50L12.5 37.5L25 25L50 0Z",
    fill: "#59529D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 25V50L37.5 37.5L50 25Z",
    fill: "#5271B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25L0 50V0L25 25Z",
    fill: "#BB4B96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_21469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotion);
export default __webpack_public_path__ + "static/media/motion.dc867b9f86a828de2cc3fe71f431e7aa.svg";
export { ForwardRef as ReactComponent };